import getAccountErrorMessage from "@saleor/utils/errors/account";

export function useValidation(initialForm) {
  const {
    acctName,
    acctNum,
    bankAddress,
    bankName,
    cluster,
    contractId,
    designation,
    financeName,
    financeEmailAddress,
    financeMobileNum,
    ipay88SubMid,
    mallBranch,
    authorizeEmailAddress,
    authorizeMobileNum,
    paymentFeeRate,
    rentalType,
    sellerBrand,
    signatoryName,
    isActivateCompanyDetails,
    isUseTenantCluster,
    location
  } = initialForm;

  const ipayMessage = () => {
    if (ipay88SubMid === "") {
      return null;
    }

    return null;
  };

  const locationMessage = () => {
    if (!!location && location.length > 40) {
      return "Should not exceed 40 characters";
    }

    return null;
  };

  const subTenantTypeMessage = () => null;

  const sellerBrandMessage = () => {
    if (sellerBrand === "") {
      return "This field is required.";
    }

    return null;
  };

  const mallMessage = () => {
    if (mallBranch === "") {
      return "This field is required.";
    }

    return null;
  };

  const acctNameMessage = () => {
    if (
      acctName === "" &&
      (isActivateCompanyDetails === "true" || isActivateCompanyDetails === true)
    ) {
      return "This field is required.";
    }

    return null;
  };

  const acctNumMessage = () => {
    if (
      acctNum === "" &&
      (isActivateCompanyDetails === "true" || isActivateCompanyDetails === true)
    ) {
      return "This field is required.";
    }

    return null;
  };

  const bankAddressMessage = () => {
    if (
      bankAddress === "" &&
      (isActivateCompanyDetails === "true" || isActivateCompanyDetails === true)
    ) {
      return "This field is required.";
    }

    return null;
  };

  const bankNameMessage = () => {
    if (
      bankName === "" &&
      (isActivateCompanyDetails === "true" || isActivateCompanyDetails === true)
    ) {
      return "This field is required.";
    }

    return null;
  };

  const contractIdMessage = () => {
    if (contractId === "") {
      return "This field is required.";
    }

    return null;
  };

  const designationMessage = () => {
    if (designation === "") {
      return "This field is required.";
    }

    return null;
  };

  const financeNameMessage = () => {
    if (
      financeName === "" &&
      (isActivateCompanyDetails === "true" || isActivateCompanyDetails === true)
    ) {
      return "This field is required.";
    }

    return null;
  };

  const financeEmailAddressMessage = () => {
    if (
      financeEmailAddress === "" &&
      (isActivateCompanyDetails === "true" || isActivateCompanyDetails === true)
    ) {
      return "This field is required.";
    }

    return null;
  };

  const financeMobileNumMessage = () => {
    if (
      financeMobileNum === "" &&
      (isActivateCompanyDetails === "true" || isActivateCompanyDetails === true)
    ) {
      return "This field is required.";
    }

    return null;
  };
  const authorizeEmailAddressMessage = () => {
    if (authorizeEmailAddress === "") {
      return "This field is required.";
    }

    return null;
  };

  const authorizeMobileNumMessage = () => {
    if (authorizeMobileNum === "") {
      return "This field is required.";
    }

    return null;
  };

  const signatoryNameMessage = () => {
    if (signatoryName === "") {
      return "This field is required.";
    }

    return null;
  };
  const paymentFeeRateMessage = () => {
    if (paymentFeeRate === "" || paymentFeeRate === null) {
      return "This field is required.";
    }
    return null;
  };
  const rentalTypeMessage = () => {
    if (rentalType === "" || rentalType === null) {
      return null;
    }
    return null;
  };

  const clusterMessage = () => {
    if (cluster === "" && isUseTenantCluster) {
      return "This field is required";
    }
    return null;
  };

  return {
    acctName: acctNameMessage(),
    acctNum: acctNumMessage(),
    authorizeEmailAddress: authorizeEmailAddressMessage(),
    authorizeMobileNum: authorizeMobileNumMessage(),
    bankAddress: bankAddressMessage(),
    bankName: bankNameMessage(),
    cluster: clusterMessage(),
    contractId: contractIdMessage(),
    designation: designationMessage(),
    financeEmailAddress: financeEmailAddressMessage(),
    financeMobileNum: financeMobileNumMessage(),
    financeName: financeNameMessage(),
    ipay88SubMid: ipayMessage(),
    location: locationMessage(),
    mallBranch: mallMessage(),
    paymentFeeRate: paymentFeeRateMessage(),
    rentalType: rentalTypeMessage(),
    sellerBrand: sellerBrandMessage(),
    signatoryName: signatoryNameMessage(),
    subTenantType: subTenantTypeMessage()
  };
}

export const checkError = (key, formErrors, validationError, intl) => ({
  hasError: !!formErrors[key] || !!validationError[key],
  message: formErrors[key]
    ? getAccountErrorMessage(formErrors.oldPassword, intl)
    : validationError[key]
});

export const hasNoError = validationError => {
  let thisReturn = true;
  Object.keys(validationError).forEach(key => {
    if (thisReturn) {
      thisReturn = validationError[key] === null;
    }
  });
  return thisReturn;
};
